import { Typography, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { Table } from '../../../../../../components/table'
import { TechnologiesSelectors } from '../../../../../../store/technologies'
import { ProjectStatusTag } from './ProjectStatusTag'
import {useNavigate} from "react-router-dom";

const TableHeader = ['Title', 'Status', 'Grant count']

export const ProjectsTable = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const projects = useSelector(TechnologiesSelectors.makeTechnologies)

  const headerCells = TableHeader.map((header, index) => {
    return {
      content: (
        <Typography key={index} color="secondary" fontWeight={500} fontSize="0.9rem">
          {header}
        </Typography>
      ),
    }
  })

  const rows: any[] =
    projects &&
    projects.map((rowCell: any) => {
      const cells = [
        {
          content: (
            <Typography
              color="secondary"
              fontSize="0.875rem"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.title}
            </Typography>
          ),
          cellProps: {
            sx: { maxWidth: 300 },
          },
        },
        {
          content: <ProjectStatusTag status={rowCell.active} />,
        },
        {
          content: (
            <Typography
              fontSize="0.875rem"
              color="secondary.light"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.matchedGrants_count}
            </Typography>
          ),
          cellProps: {
            sx: { display: { xs: 'none', sm: 'table-cell' } },
          },
        },
      ].filter(Boolean)

      return {
        rowProps: {
          onClick: ()=> navigate(`/projects/${rowCell._id}`),
          sx: {
            background: 'white',
            '&:hover': { cursor: 'pointer', background: theme.palette.grey[100] },
          },
        },
        cells,
      }
    })

  return (
    <Table
      containerProps={{
        sx: {
          boxShadow: 'none',
          background: 'transparent',
        },
      }}
      head={{
        containerProps: {
          sx: { borderRadius: '8px', background: theme.palette.grey[200], width: '100%' },
        },
        rows: [{ cells: headerCells || [] }],
      }}
      body={{ rows }}
    />
  )
}
